import {
   Modal,
   ModalCancelButton,
   ModalCloseButton,
   ModalConfirmButton,
   ModalWidth,
   ValidateFormEventInterceptor,
} from '@dreryk/react-components';

import { translationKeys } from '../translations';

import { usePatientMedicalInformationFaultModal } from './PatientMedicalInformationFaultModal.hooks';
import { PatientMedicalInformationRemoveForm } from './PatientMedicalInformationRemoveForm';
import { MedicalInformationMarkAsRemovedActionInterceptor } from './interceptors/MedicalInformationMarkAsRemovedActionIntereceptor';

type PatientMedicalInformationRemoveModalProps = Readonly<{
   medicalInformationId: number;
   onClose: VoidFunction;
   onRemoveSuccess: VoidFunction;
}>;

export const PatientMedicalInformationRemoveModal = (props: PatientMedicalInformationRemoveModalProps): JSX.Element => {
   const {
      openPatientMedicalInformationFaultModal: openLinkedToMedicalEventFaultModal,
      renderPatientMedicalInformationFaultModal: renderLinkedToMedicalEventFaultModal,
   } = usePatientMedicalInformationFaultModal();

   const {
      openPatientMedicalInformationFaultModal: openLinkedToVisitFaultModal,
      renderPatientMedicalInformationFaultModal: renderLinkedToVisitFaultModal,
   } = usePatientMedicalInformationFaultModal();

   return (
      <>
         <Modal
            testId={'patientMedicalInformationRemoveModal'}
            title={translationKeys.removingMedicalInformation}
            width={ModalWidth.NORMAL}
         >
            <PatientMedicalInformationRemoveForm>
               {({ handleSubmit, trigger }) => (
                  <ValidateFormEventInterceptor trigger={trigger}>
                     <MedicalInformationMarkAsRemovedActionInterceptor
                        onSuccess={props.onRemoveSuccess}
                        handleSubmit={handleSubmit}
                        medicalInformationId={props.medicalInformationId}
                        onMedicalInformationLinkedToMedicalEventFault={openLinkedToMedicalEventFaultModal}
                        onMedicalInformationLinkedToVisitFault={openLinkedToVisitFaultModal}
                     >
                        <ModalConfirmButton label={translationKeys.markAsRemoved} onClick={props.onClose} />
                     </MedicalInformationMarkAsRemovedActionInterceptor>

                     <ModalCloseButton onClick={props.onClose} />
                     <ModalCancelButton onClick={props.onClose} />
                  </ValidateFormEventInterceptor>
               )}
            </PatientMedicalInformationRemoveForm>
         </Modal>

         {renderLinkedToMedicalEventFaultModal({
            description: translationKeys.youCannotRemoveAnEntryBecauseItHasBeenSentToP1,
         })}

         {renderLinkedToVisitFaultModal({
            description: translationKeys.youCannotRemoveAnEntryBecauseItIsRelatedToAVisit,
         })}
      </>
   );
};
